import { useState, useEffect } from 'react';
import styles from './RoboKidsPage.module.css';

export default function RoboKidsPage3() {
  const [guardianName, setGuardianName] = useState('');
  const [email, setEmail] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zip, setZip] = useState('');
  const [childName, setChildName] = useState('');
  const [childAge, setChildAge] = useState('');
  const [startDate, setStartDate] = useState('');
  const [slideshowIndex, setSlideshowIndex] = useState(0);
  const [secondSlideshowIndex, setSecondSlideshowIndex] = useState(0);
  const [submitting, setSubmitting] = useState(false);

  const availableDates = ['2026-02-10', '2026-02-11', '2026-02-12', '2026-02-13'];

  const placeholderImages = [
    '/images/robokids-advanced/kit-closeup3.png',
    '/images/robokids-advanced/light-switch-guide.png',
    '/images/robokids-advanced/placeholder5.png',
  ];

  const secondSlideshowImages = [
    '/images/robokids-advanced/robokids3.png',
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setSlideshowIndex((prev) => (prev + 1) % placeholderImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondSlideshowIndex((prev) => (prev + 1) % secondSlideshowImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

 const handleRegister = async (e) => {
  e.preventDefault();
  setSubmitting(true);

  const formData = {
    guardianName,
    childName,
    childAge,
    email,
    addressLine1: address1,
    addressLine2: address2,
    city,
    state,
    zipCode: zip,
    startDate,
    classType: 'advanced',
  };

  try {
    const response = await fetch("https://vgiqj6ha4n5pewmu4zkwhsac740nucsz.lambda-url.us-east-1.on.aws/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (response.ok && data.checkoutUrl) {
      sessionStorage.setItem("roboKidsWaiverSession", JSON.stringify(formData));
      window.location.href = data.checkoutUrl;
    } else {
      alert(data.message || "Registration failed. Please try again.");
    }
  } catch (error) {
    console.error("Error submitting registration:", error);
    alert("Something went wrong. Please try again.");
  } finally {
    setSubmitting(false);
  }
};




  return (
    <div className={styles.roboKidsWrapper}>
      {/* Left column: registration form */}
      <div className={styles.leftColumn}>
        <h2>Register for Robo Kids Advanced level Class!</h2>
        <form className={styles.form} onSubmit={handleRegister}>
          <label>Guardian Name:</label>
          <input type="text" required value={guardianName} onChange={(e) => setGuardianName(e.target.value)} />
          <label>Email:</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          <label>Address Line 1:</label>
          <input type="text" required value={address1} onChange={(e) => setAddress1(e.target.value)} />
          <label>Address Line 2 (optional):</label>
          <input type="text" value={address2} onChange={(e) => setAddress2(e.target.value)} />
          <label>City:</label>
          <input type="text" required value={city} onChange={(e) => setCity(e.target.value)} />
          <label>State:</label>
          <input type="text" required value={state} onChange={(e) => setState(e.target.value)} />
          <label>ZIP Code:</label>
          <input type="text" required pattern="\d{5}" value={zip} onChange={(e) => setZip(e.target.value)} />
          <label>Child’s First Name:</label>
          <input type="text" required value={childName} onChange={(e) => setChildName(e.target.value)} />
          <label>Child’s Age:</label>
          <input type="number" required min="5" value={childAge} onChange={(e) => setChildAge(e.target.value)} />
          <label>Choose Class Start Date:</label>
          <select required value={startDate} onChange={(e) => setStartDate(e.target.value)}>
            <option value="">Select a date</option>
            {availableDates.map(date => (
              <option key={date} value={date}>
                {new Date(date + "T00:00:00").toLocaleDateString(undefined, {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric'
                })}
              </option>
            ))}
          </select>

          <button type="submit" disabled={submitting} className={styles.registerButton}>
            {submitting ? "Processing..." : "Proceed to Payment"}
          </button>
        </form>
      </div>

      {/* Middle column: slideshows */}
      <div className={styles.slideshowColumn}>
        <div className={styles.slideshowContainer}>
          <img
            src={placeholderImages[slideshowIndex]}
            alt={`Slideshow image ${slideshowIndex + 1}`}
            className={styles.slideshowImage}
          />
          <p>Enroll your child today!</p>
        </div>
        <div className={styles.slideshowContainer}>
          <img
            src={secondSlideshowImages[secondSlideshowIndex]}
            alt={`Second slideshow image ${secondSlideshowIndex + 1}`}
            className={styles.slideshowImage}
          />
          <p style={{ fontSize: '0.75rem', color: '#777' }}>
            Actual kit contents may vary in types, essential components will be the same.
          </p>
        </div>
      </div>

   {/* Right column: About + FAQ */}

<div className={styles.rightColumn}>
  <h2>Advanced AI Robotics Mastery – $750</h2>
  <p>
    In this level, kids master <strong>autonomous robotics</strong>. They’ll build robots
    that follow lines, avoid obstacles, and use AI logic to make decisions — creating
    machines that seem to “think” on their own.
  </p>
  <ul>
    <li><strong>What's Included:</strong>
      <ul>
        <li>Full robotics kit with upgraded motors, servos, and sensors</li>
        <li>Advanced AI control board (Arduino-compatible with expansion pins)</li>
        <li>High-level sensor suite: ultrasonic, infrared, and light tracking modules</li>
        <li>Chassis and assembly materials for durable builds</li>
        <li>Digital coding guide with sample AI algorithms</li>
      </ul>
    </li>
    <li><strong>8-Week Program (1 session/week):</strong> Live video call sessions, team challenges, and project reviews.</li>
    <li><strong>What Kids Will Learn:</strong>
      <ul>
        <li>Autonomous navigation: line following and obstacle avoidance</li>
        <li>AI decision trees and condition-based responses</li>
        <li>Combining multiple sensors for complex tasks</li>
        <li>Collaborative robotics and advanced problem solving</li>
      </ul>
    </li>
    <li><strong>Recommended Age:</strong> 10–15 years. Completion of Level 2 or equivalent skills advised.</li>
  </ul>

  <div className={styles.faqBox}>
    <h3>❓ Frequently Asked Questions</h3>
    <details><summary><strong>What age is this for?</strong></summary><p>Ages 10–15. Level 2 completion or similar experience recommended.</p></details>
    <details><summary><strong>Do kids need coding knowledge?</strong></summary><p>Basic coding helps, but we introduce AI programming concepts step by step.</p></details>
    <details><summary><strong>What’s special about this course?</strong></summary><p>This is where kids learn true autonomy — robots that respond intelligently without direct control.</p></details>
    <details><summary><strong>Do we need special hardware?</strong></summary><p>No. All necessary sensors, motors, and boards are included.</p></details>
    <details><summary><strong>Are sessions interactive?</strong></summary><p>Yes, kids share progress and get feedback live during video calls.</p></details>
  </div>
</div>


    </div>

  );
}
